import React from 'react';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import StatusAlertCard from './StatusAlertCard';

function SentToCompanyAlert() {
  return (
    <StatusAlertCard tone="success" icon={faPaperPlane} title="Inviato in compagnia">
      <p>
        Il preventivo è stato inviato alla compagnia. Riceverai
        una notifica non appena la compania risponderà.
      </p>
    </StatusAlertCard>
  );
}

export default SentToCompanyAlert;
